import React from "react";
import MuiAlert from "@mui/material/Alert";

// Source
import ControllerAlert from "../controller/Alert";
import ControllerLocalization from "../controller/Localization";

let isRendered = false;

const viewAlert: React.FC = () => {
    // Variable
    const controllerAlert = new ControllerAlert(isRendered);
    const controllerLocalization = new ControllerLocalization(isRendered);

    // Method
    controllerAlert.initializeHook();
    controllerLocalization.initializeHook();

    // Render
    isRendered = true;

    if (controllerAlert.getStorageMain && controllerLocalization.getStorageMain) {
        return (
            <MuiAlert
                onClose={controllerAlert.close}
                severity={controllerAlert.getStorageMain.alertType}
                className={`view_alert ${controllerAlert.getIsShow ? "visible" : "hidden"}`}
                data-at_id="view_alert"
            >
                <div>{controllerAlert.getStorageMain.message}</div>
            </MuiAlert>
        );
    } else {
        return <></>;
    }
};

export default viewAlert;
